// extracted by mini-css-extract-plugin
export default {"container":"f3_JZ6vx5b55VNBjoS7F","fixedHeight":"lFW1GRDLMGOx5Z4Od9SH","spaceless":"DJQuT3pptIh50Alfue5X","wrapper":"n0vnrhJKPpxprZbXoqng","fullscreen":"cWCaH5FG5R3dxT0D9hzm"};